<!-- Boton solo en moviles para abrir overlay -->
<ng-container *ngIf="isMobile$ | async">
	<div class="mobile-actions">
		<button mat-icon-button (click)="abrirOverlay()">
			<mat-icon>filter_list</mat-icon>
		</button>
		<button mat-flat-button color="primary" class="search-button" [disabled]="loading" (click)="submit()">
			<mat-icon>search</mat-icon>
			{{ loading ? 'Buscando...' : btLabel }}
		</button>
	</div>
</ng-container>

<!-- Inline en escritorio -->
<ng-container *ngIf="!(isMobile$ | async)">
	<mat-card class="filtros-card">
		<ng-container *ngTemplateOutlet="formFiltros"></ng-container>
	</mat-card>
</ng-container>

<!-- Overlay en moviles -->
<div class="overlay" *ngIf="showOverlay">
	<div class="overlay-content">
		<mat-card class="filtros-card">
			<div class="overlay-header">
				<h3>Filtros</h3>
				<button mat-icon-button (click)="cerrarOverlay()">
					<mat-icon>close</mat-icon>
				</button>
			</div>
			<ng-container *ngTemplateOutlet="formFiltros"></ng-container>
		</mat-card>
	</div>
</div>

<!-- Template del formulario de filtros -->
<ng-template #formFiltros>
	<div class="filtros-form">
		<div class="filters-summary" *ngIf="activeFilterChips.length > 0">
			<div class="filters-summary-icon">
				<mat-icon>filter_alt</mat-icon>
			</div>
			<div class="filters-summary-chips">
				<button
					type="button"
					mat-stroked-button
					class="active-chip"
					*ngFor="let chip of activeFilterChips; trackBy: trackByChipKey">
					<strong>{{ chip.label }}:</strong>
					<span>{{ chip.value }}</span>
				</button>
			</div>
			<span class="summary-badge" *ngIf="summaryBadgeText">{{ summaryBadgeText }}</span>
			<button type="button" mat-button class="clear-inline" (click)="onClear()">
				<mat-icon>refresh</mat-icon>
				Limpiar filtros
			</button>
		</div>

		<div *ngFor="let filter of visibleFilters; trackBy: trackByFilterName" class="filter" [class.filter--priority]="filter.name === 'status' || filter.name === 'date' || filter.name === 'categoryId'">
			<mat-form-field appearance="outline" *ngIf="filter.type=='text' || filter.type=='number'">
				<mat-icon matPrefix>{{ getFieldIcon(filter) }}</mat-icon>
				<mat-label>{{ filter.label }}</mat-label>
				<input matInput [type]="filter.type" [name]="filter.name" [(ngModel)]="filter.value" (ngModelChange)="onFilterValueChange()" [placeholder]="filter.label" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="fecha-range"
				*ngIf="filter.type=='datetime' || filter.type=='date' || filter.type=='time'">
				<mat-icon matPrefix>{{ getFieldIcon(filter) }}</mat-icon>
				<mat-label>{{ filter.label }}</mat-label>
				<mat-date-range-input [rangePicker]="picker">
					<input matStartDate placeholder="Desde" name="{{filter.name}}_from" [(ngModel)]="filter.values[0]"
						(dateChange)="onDateChange(filter.name, 0, $event)" />
					<input matEndDate placeholder="Hasta" name="{{filter.name}}_to" [(ngModel)]="filter.values[1]"
						(dateChange)="onDateChange(filter.name, 1, $event)" />
				</mat-date-range-input>
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker></mat-date-range-picker>
			</mat-form-field>

			<mat-form-field *ngIf="filter.type=='select'" appearance="outline">
				<mat-icon matPrefix>{{ getFieldIcon(filter) }}</mat-icon>
				<mat-label>{{ filter.label }}</mat-label>
				<mat-select [name]="filter.name" [(ngModel)]="filter.value" [multiple]="filter.multiple" (ngModelChange)="onSelectChange(filter)">
					<mat-option *ngFor="let option of filter.options" [value]="isOption(option) ? option.value : option">
						{{ isOption(option) ? option.label : option }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<app-category-selector
				*ngIf="filter.type=='category'"
				[selectedValue]="filter.value"
				(onChangeValue)="categoryOnChangeValue(filter, $event)">
			</app-category-selector>

			<app-user-search-select
				*ngIf="filter.type=='user-search'"
				[(selectedUser)]="filter.selectedUser"
				[label]="filter.label"
				[noDataLabel]="filter.noDataLabel || 'finance.payment.assing.selectedUser.nodata'"
				[placeholder]="filter.placeholder || 'Ej. Ana, ana@correo.com, +34...'"
				[searchField]="filter.searchField || 'text'"
				(selectedUserChange)="userOnChangeValue(filter, $event)">
			</app-user-search-select>
		</div>

		<div class="acciones">
			<div class="acciones-left">
				<button mat-flat-button color="primary" class="search-button" [disabled]="loading" (click)="submit()">
					<mat-icon>search</mat-icon>
					{{ loading ? 'Buscando...' : btLabel }}
				</button>

				<mat-form-field *ngIf="massiveAccions?.length > 0" appearance="outline" class="acciones-masivas">
					<mat-label>Acciones masivas</mat-label>
					<mat-select #actionSelect (selectionChange)="onChangeMassiveAction(actionSelect.value)">
						<mat-option *ngFor="let accion of massiveAccions" [value]="accion">
							{{ accion.key }}
						</mat-option>
					</mat-select>
					<button
						mat-icon-button
						matSuffix
						(click)="onClickMassiveAction(actionSelect.value.key)"
						[disabled]="loading || !actionSelect.selected || !actionSelect.value?.enabled"
						aria-label="Ejecutar">
						<mat-icon>play_arrow</mat-icon>
					</button>
				</mat-form-field>

				<button *ngFor="let accion of accions" mat-stroked-button color="primary" [disabled]="loading" (click)="submit(accion)">
					{{ accion }}
				</button>

				<button
					*ngIf="hasSecondaryFilters"
					mat-stroked-button
					type="button"
					class="more-filters-button"
					(click)="toggleAdvancedFilters()">
					<mat-icon>tune</mat-icon>
					{{ showAdvancedFilters ? 'Menos filtros' : 'Mas filtros' }}
					<mat-icon>{{ showAdvancedFilters ? 'expand_less' : 'expand_more' }}</mat-icon>
				</button>
			</div>

			<div class="acciones-right" *ngIf="!(isMobile$ | async)">
				<button mat-button (click)="onClear()">
					<mat-icon>refresh</mat-icon>
					Limpiar
				</button>
			</div>

			<button *ngIf="isMobile$ | async" mat-stroked-button type="button" (click)="cerrarOverlay()">
				CANCELAR
			</button>
		</div>
	</div>
</ng-template>
